<template>
  <div class="content">
     <b-card
        class="mb-2">

        <div>
            <h1>Upload Contacts</h1>
            <p class="grey-400"><a href="https://storage.googleapis.com/4degrees_assets/data/voter_data_template.csv" download class="grey-400">Download example template with correct headers</a></p>
        </div>
       <div v-if="errors.length > 0">
            <b-alert show variant="danger" v-for="upload_error in errors" :key="upload_error"
                            :error_text="upload_error" >
                <strong>{{upload_error}}</strong>
            </b-alert>
        </div>


        <div :class="{ show_dropzone: !this.upload_in_progress, hide_dropzone: this.upload_in_progress }">
            <div class="dropzone_contain">
                <b-form-group >

                    <el-upload
                    
                    class="upload-demo"
                    ref="upload_csv"
                    :on-change="handlePreview"
                    :on-remove="remove_file"
                    drag
                    :multiple="this.multiple"
                    :limit=1
                    action=""
                    accept="text/csv"
                    :auto-upload="false">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                    </el-upload>
        
                </b-form-group>
            </div>
        </div>

        <div :class="{ show_dropzone: this.upload_in_progress, hide_dropzone: !this.upload_in_progress}">
            <div class="el-upload-dragger">
                <div class="progress-wrapper"  >
                    <div class="progress-success">
                        <div class="progress-label">
                        <span>Uploaded Progress:</span>
                        </div>
                        <div class="progress-percentage">
                        <span>{{this.uploadPercentage}}%</span>
                        </div>
                    </div>
                    <base-progress
                                    type="success" animated
                                    :value="uploadPercentage"
                                    size="lg">
                                    :height="10"
                    </base-progress>
                </div>
            </div>
        </div>

        <br>

        <!-- preview the csv file -->
        <div v-if="files" :class="{ hide: this.upload_in_progress }" transition="expand">
            <div class="csv_table_preview_contain">
                <b-table
                :refreshed="this.parse_column_headers_set_styles()"
                :striped="preview_table.striped"
                :bordered="preview_table.bordered"
                :outlined="preview_table.outlined"
                :small="preview_table.small"
                :hover="preview_table.hover"
                :items="preview_table.items"
                :fields="preview_table.fields"
                id="csv_preview_table"
                ></b-table>
            </div>
        </div>

        <div v-if="column_error_summary_text">
            <b-alert show dismissible variant="danger" class="mt-3">
                <span class="alert-icon"><i class="ni ni-notification-70"></i></span>
                <span class="alert-text"><strong>Column name not supported!</strong> These columns will NOT be parsed: <strong> {{this.column_error_summary_text}}</strong>.</span>
                
            </b-alert>
        </div>
        

        <div v-if="files.length > 0" transition="expand" class="mt-5">
            <b-form-group :class="{ hide: this.upload_in_progress }" transition="expand">
                <base-input label="Contact List to Upload Into" :disabled="this.upload_in_progress">
                    <el-select v-model="upload_data.list_uuid" filterable
                            placeholder="Type">
                    <el-option v-for="list in $parent.contact_lists"
                                :key="list.list_uuid"
                                :label="list.list_name"
                                :value="list.list_uuid">
                    </el-option>
                    </el-select>
                </base-input>
            </b-form-group>

            <b-form-group :class="{ hide: this.upload_in_progress }" transition="expand">
                <base-input label="Type" :disabled="this.upload_in_progress">
                    <el-select v-model="upload_data.list_type" filterable
                            placeholder="Type">
                    <el-option v-for="option in list_type_options"
                                :key="option"
                                :label="option"
                                :value="option">
                    </el-option>
                    </el-select>
                </base-input>
            </b-form-group>

          
            <b-form-group class="mt-2">

                <base-button icon type="success" v-on:click="submitFile()" :disabled="this.upload_in_progress">
                    <span class="btn-inner--icon"><i class="ni ni-cloud-upload-96"></i></span>
                    <span class="btn-inner--text">Upload</span>
                </base-button>

                
   
            </b-form-group>
        </div>

    
        
    </b-card>
  </div>
  
</template>
<script>
import { Select, Option, Upload } from 'element-ui';
import swal from 'sweetalert2';
import FileInput from '@/components/Inputs/FileInput'
import papaparse from 'papaparse'
import { BModal } from 'bootstrap-vue'




export default {
 components: { 
    FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Upload.name]: Upload,
    swal,
    BModal
  },
  data() {
      return {
        required: true,
        is_preview_loaded: false,
        multiple:false,
        files: [],
        dragAndDropCapable: false,
        upload_in_progress: false,
        uploadPercentage: 0,
        list_type_options: ['SMS'],
        upload_data: {
          list_type: 'SMS',
          list_uuid: null
        },
        errors: [],
        preview_table: {
            fields: [],
            items: [],
            striped: true,
            bordered: true,
            outlined: true,
            small: true,
            hover: true,
            column_error_index: [],
            column_error_strings: []
        },
       
      }
      
  },
  computed: {
       column_error_summary_text: function() {
            if(this.preview_table.column_error_strings && this.preview_table.column_error_strings.length && this.preview_table.column_error_strings.length === 0) {
                return null
            } else {
                return this.preview_table.column_error_strings.join(", ")
            }   
       }
  },
  methods: {
    remove_file(file,files) {
        this.clear_upload_state()
        console.log('remove file')
    },
    handlePreview(file,files) {//file
        console.log(file)
        console.log(files)
        this.files = files
        //let file = event.raw
        // Check if the file is an image.
        if (file.type && !file.type.startsWith('text/csv')) {
            console.log('File is not an csv.');

            //this.set_is_preview_loaded_false()
            return swal.fire({
                title: `File must be a .CSV`,
                text: 'Please only import a standard comma seperated dot csv file',
                buttonsStyling: false,
                icon: 'warning'
            })

        }

        var reader = new FileReader();
        reader.onload = (reader) => {
            let count_rows = 0
            papaparse.parse(reader.target.result, {
                worker: true,
                //header:true,
                delimiter: ",",
                download: false,
                preview: 6,
                step: (row) => {
                    if(count_rows === 0) {
                        row.data.forEach((column_header,index) => {
                            this.preview_table.fields.push(column_header)

                            //switch is valid column _ names
                            switch (column_header) {
                                case 'first_name':
                                    break;
                                case 'last_name':
                                    break;
                                case 'cell_phone':
                                    break;
                                case 'email':
                                    break;
                                case 'address':
                                    break;
                                case 'city':
                                    break;
                                case 'state':
                                    break;
                                case 'zip':
                                    break;
                                case 'gender':
                                    break;
                                case 'van_id':
                                    break;
                                case 'is_external_sms_optout':
                                    break;
                                case 'do_not_call':
                                    break;
                                case 'primary_phone':
                                    break;
                                case 'json_contact_data':
                                    //TODO is it possible to try and json parse these for the 5 preview rows?
                                   break;
                                //do not support yet wait until test the backend and make sql queryable
                                case 'custom_key':
                                    break;
                                case 'custom_value':
                                    break;
                                case 'external_contact_uuid':
                                    break;
                                case 'external_contact_uuid_source':
                                    break;
                                
                                //230308 add a skip skip_twilio_verified_cell
                                case 'skip_twilio_verified_cell':
                                    break;

                                case 'twilio_verified_cell':
                                    break;
                                case 'twilio_caller_name':
                                    break;
                                case 'twilio_carrier_error_code':
                                    break;
                                case 'twilio_carrier_mobile_country_code':
                                    break;
                                case 'twilio_carrier_mobile_network_code':
                                    break;
                                case 'twilio_carrier_name':
                                    break;
                                case 'twilio_carrier_type':
                                    break;
                                case 'twilio_country_code':
                                    break;
                                case 'twilio_national_format':
                                    break;
                                case 'twilio_verified_cell_last_modified':
                                    break;
                                
                                default:
                                    this.preview_table.column_error_index.push(index)
                                    this.preview_table.column_error_strings.push(column_header)
                                    //push into an error??
                                    break;
                            }
                            
                        });
                        
                        count_rows++
                       
                    } else {
                        count_rows++
                        let this_row_object = {}
                        
                        for (let index = 0; index < row.data.length; index++) {
                            this_row_object[this.preview_table.fields[index]] = row.data[index]
                        }
                        this.preview_table.items.push(this_row_object)
                        

                    } 
                },
                complete: (event) => {
                    
                },
                error: (error,file) => {
                    console.log(error)
                    return swal.fire({
                        title: `Error parsing this file`,
                        text: 'Please double check this is a correct CSV file',
                        buttonsStyling: false,
                        icon: 'warning'
                    })
                }
            });

        }

        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsText(this.files[0].raw, "UTF-8");

    },
    parse_column_headers_set_styles() {
        let table_colors = (the_table_header_th_elements) => {
            for (let header_index = 0; header_index < the_table_header_th_elements.length; header_index++) {
                //if there are no errors color them all green
                if(this.preview_table.column_error_index.length === 0) {
                    the_table_header_th_elements[header_index].classList.add("green_bkg")
                } else {
                
                    this.preview_table.column_error_index.forEach((column_index_array,column_index) => {
                        //compare if there is this array number in the error col index
                        if(column_index_array === header_index) {
                            //turn red
                            the_table_header_th_elements[header_index].classList.add("red_bkg")
                        } else {
                            //turn green
                            the_table_header_th_elements[header_index].classList.add("green_bkg") 
                        }
                    });
                }
            }
        }

        if(this.preview_table.items && this.preview_table.items.length && this.preview_table.items.length >0) {
            vm.$nextTick(function () {
                let the_table_header_th_elements = document.getElementById("csv_preview_table")
                if(the_table_header_th_elements) {
                    the_table_header_th_elements = the_table_header_th_elements.getElementsByTagName("th")
                    table_colors(the_table_header_th_elements)
                } else {
                    setTimeout(() => {
                        let the_table_header_th_elements = document.getElementById("csv_preview_table")
                        the_table_header_th_elements = the_table_header_th_elements.getElementsByTagName("th")
                        table_colors(the_table_header_th_elements)
                    }, 300);
                }
                
                
            })
            
        }
            
    },
    set_is_preview_loaded_false() {
        this.is_preview_loaded = false
    },
    clear_upload_state() {
        //clear it
        console.log('clear it')
        this.uploadPercentage = 0
        this.files = []
        this.upload_data = {
            list_type: 'SMS',
            list_uuid: null
        }
        //clear any erors 
        this.errors = []
        this.upload_in_progress = false

        this.preview_table.column_error_strings = []
        this.preview_table.column_error_index = []
        this.preview_table.fields = []
        this.preview_table.items = []

        this.$refs.upload_csv.clearFiles()
    },
    submitFile(){

        this.upload_in_progress = true

        //error check
        //make sure has a few details
        if(!this.upload_data.list_type) {
            this.errors.push("Must have a list type")
        } else {
            this.errors = this.errors.filter(e => e !== "Must have a list type")
        }

        if(!this.upload_data.list_uuid) {
            this.errors.push("Must have a list selected")
        } else {
            this.errors = this.errors.filter(e => e !== "Must have a list selected")
        }

        if(typeof this.preview_table.column_error_strings !== 'undefined' && this.preview_table.column_error_strings.length && this.preview_table.column_error_strings.length > 0) {
            swal.fire({
                title: `ERROR:`,
                text: 'Bad column name. Download example file. Use underscore_case like sent_to, first_name, address',
                buttonsStyling: false,
                icon: 'warning'
            })
            return this.clear_upload_state()
        }


        if(this.errors.length && this.errors.length > 0) {
            swal.fire({
                title: `ERROR:`,
                text: 'Please fix the errors above',
                buttonsStyling: false,
                icon: 'warning'
            })
            return this.clear_upload_state()
        }

    
        let formData = new FormData();

        
        formData.append('org_id', this.$parent.active_org.org_id);
        formData.append('list_type', this.upload_data.list_type);
        formData.append('this_user_uuid', this.$parent.active_user.user_uuid);
        formData.append('list_uuid', this.upload_data.list_uuid);

        formData.append('file', this.files[0].raw); //TODO if allowing multiple files figure this out

    
        
        axios.post( 'https://'+this.$parent.use_this_api_domain+'/contact/upload',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                },
                onUploadProgress: function( progressEvent ) {
                    //console.log(progressEvent)
                    this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))
                    console.log('uploadPercentage: ' +  this.uploadPercentage)
                }.bind(this)
            }
        )
        .then((result) => {
            console.log(result.data)
            let success_rows = result.data.success_rows
            let error_rows = result.data.broken_rows
            let the_text = 'You uploaded ' + success_rows + ' rows.'
            let missing_column_string = result.data.missing_fields
            if(error_rows && error_rows > 0) {the_text = the_text + ' There were ' + error_rows + ' rows with errors.'}
            if(missing_column_string && missing_column_string !== null && missing_column_string.length && missing_column_string.length >0) {
                the_text = the_text + ' You must include at least one unique user identification column, such as cell_phone, van_id, or email'
            }
            swal.fire({
                title: `Success!`,
                text: the_text,
                buttonsStyling: false,
                icon: 'success'
            })
            
            //set a timeout then reload contact
            //send in a var in wrapper because it's clearing the list_uuid before the timeout?
            var load_new_contacts = (this_list_uuid) => {
                setTimeout(() => {
                    this.$parent.grab_new_contacts(10,this_list_uuid)

                    this.$parent.refresh_contact_list_stats(this_list_uuid,0,5000)

                },10000)
            }
            
            if(this.upload_data.list_uuid && this.upload_data.list_uuid !== null) {
                let this_list_uuid = this.upload_data.list_uuid
                load_new_contacts(this_list_uuid)
            }
            

            return this.clear_upload_state()

        })
        .catch((result) => {
            console.log(result)
            swal.fire({
                title: `Error Uploading`,
                text: 'Make sure your file is formatted with correct headers',
                buttonsStyling: false,
                icon: 'warning'
            })

            return this.clear_upload_state()
        })
        
    },

    determineDragAndDropCapable(){
        var div = document.createElement('div');
        return ( ( 'draggable' in div )
            || ( 'ondragstart' in div && 'ondrop' in div ) )
            && 'FormData' in window
            && 'FileReader' in window;
    },
    removeFile( key ){
    this.files.splice( key, 1 );
    }
    },
    mounted() {
        
    }



  
};
</script>
<style>
.el-upload-dragger, .upload_contain, .el-upload {
    width: 100%;
        display: inline-block;
    position: relative;
}
.el-upload-list__item {

    line-height: 2em;
    border-bottom: 1px solid var(--blue);
    font-size: 24px;
    background-color: #f5f7fa;
}   
/* always present */
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.green_bkg {
    background: var(--success);
    color:var(--white) !important;
}
.red_bkg {
    background: var(--danger);
    color:var(--white) !important;
}
.hide {
    opacity: .8;
    transition: all .3 ease;
}
.show_dropzone {
    display:inline-block !important;
    width: 100%;
}
.hide_dropzone {
    display:none !important;
    width: 100%;
}
</style>
